/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AmountUnit,
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    DurationUnit,
    DurationUnitFromJSON,
    DurationUnitFromJSONTyped,
    DurationUnitToJSON,
    EmailTemplate,
    EmailTemplateFromJSON,
    EmailTemplateFromJSONTyped,
    EmailTemplateToJSON,
    RewardType,
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateRewardConfigRequestBody
 */
export interface CreateRewardConfigRequestBody {
    /**
     * 
     * @type {RewardType}
     * @memberof CreateRewardConfigRequestBody
     */
    type: RewardType;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldEmailUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldEmailAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldSendNotificationWeb: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRewardConfigRequestBody
     */
    shouldSendNotificationDevourPlay: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    amount?: number;
    /**
     * 
     * @type {AmountUnit}
     * @memberof CreateRewardConfigRequestBody
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    durationAmount?: number;
    /**
     * 
     * @type {DurationUnit}
     * @memberof CreateRewardConfigRequestBody
     */
    durationUnit?: DurationUnit;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    nftTrackerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    orderDiscountId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    questConfigId?: string;
    /**
     * 
     * @type {EmailTemplate}
     * @memberof CreateRewardConfigRequestBody
     */
    emailTemplate?: EmailTemplate;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    claimFormUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardConfigRequestBody
     */
    maxClaimCount?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardConfigRequestBody
     */
    disclaimer?: string;
}

export function CreateRewardConfigRequestBodyFromJSON(json: any): CreateRewardConfigRequestBody {
    return CreateRewardConfigRequestBodyFromJSONTyped(json, false);
}

export function CreateRewardConfigRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRewardConfigRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': RewardTypeFromJSON(json['type']),
        'name': json['name'],
        'description': json['description'],
        'shouldEmailUser': json['shouldEmailUser'],
        'shouldEmailAdmin': json['shouldEmailAdmin'],
        'shouldSendNotificationWeb': json['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': json['shouldSendNotificationDevourPlay'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'amountUnit': !exists(json, 'amountUnit') ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'durationAmount': !exists(json, 'durationAmount') ? undefined : json['durationAmount'],
        'durationUnit': !exists(json, 'durationUnit') ? undefined : DurationUnitFromJSON(json['durationUnit']),
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'nftTrackerId': !exists(json, 'nftTrackerId') ? undefined : json['nftTrackerId'],
        'orderDiscountId': !exists(json, 'orderDiscountId') ? undefined : json['orderDiscountId'],
        'promoTokenId': !exists(json, 'promoTokenId') ? undefined : json['promoTokenId'],
        'questConfigId': !exists(json, 'questConfigId') ? undefined : json['questConfigId'],
        'emailTemplate': !exists(json, 'emailTemplate') ? undefined : EmailTemplateFromJSON(json['emailTemplate']),
        'claimFormUrl': !exists(json, 'claimFormUrl') ? undefined : json['claimFormUrl'],
        'maxClaimCount': !exists(json, 'maxClaimCount') ? undefined : json['maxClaimCount'],
        'disclaimer': !exists(json, 'disclaimer') ? undefined : json['disclaimer'],
    };
}

export function CreateRewardConfigRequestBodyToJSON(value?: CreateRewardConfigRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': RewardTypeToJSON(value.type),
        'name': value.name,
        'description': value.description,
        'shouldEmailUser': value.shouldEmailUser,
        'shouldEmailAdmin': value.shouldEmailAdmin,
        'shouldSendNotificationWeb': value.shouldSendNotificationWeb,
        'shouldSendNotificationDevourPlay': value.shouldSendNotificationDevourPlay,
        'amount': value.amount,
        'amountUnit': AmountUnitToJSON(value.amountUnit),
        'durationAmount': value.durationAmount,
        'durationUnit': DurationUnitToJSON(value.durationUnit),
        'assetId': value.assetId,
        'nftTrackerId': value.nftTrackerId,
        'orderDiscountId': value.orderDiscountId,
        'promoTokenId': value.promoTokenId,
        'questConfigId': value.questConfigId,
        'emailTemplate': EmailTemplateToJSON(value.emailTemplate),
        'claimFormUrl': value.claimFormUrl,
        'maxClaimCount': value.maxClaimCount,
        'disclaimer': value.disclaimer,
    };
}


